"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_PROPS = exports.ICON_POSITION = void 0;
var TEXT_PROPS = {
  block: 'block',
  inline: 'inline',
  default: 'default',
  sub: 'sub',
  small: 'small',
  greyDark: 'greyDark',
  neutral: 'neutral'
};
exports.TEXT_PROPS = TEXT_PROPS;
var ICON_POSITION = {
  left: 'left',
  right: 'right'
};
exports.ICON_POSITION = ICON_POSITION;
var TRANSLATION = {
  noCheckedBaggage: 'This is a no checked baggage flight',
  perGuest: 'per guest',
  title: 'Baggage Allowance',
  content: "Here's how much each guest can carry on every flight"
};
exports.TRANSLATION = TRANSLATION;